import api from '@/api';
import Context from '@/models/Context';
import Item from '@/models/content/Item';

const state = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  hasMore: false,
  urlMore: ''
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },

  isUpdating(state) {
    return state.isUpdating;
  },

  isDeleting(state) {
    return state.isDeleting;
  },

  hasMore(state) {
    return state.hasMore;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  },

  setDeleting(state, value) {
    state.isDeleting = value;
  },

  setHasMore(state, value) {
    state.hasMore = value;
  },

  setUrlMore(state, value) {
    state.urlMore = value;
  }
};

const actions = {
  reset({ commit }) {
    commit('setLoading', false);
    commit('setUpdating', false);
    commit('setDeleting', false);
    commit('hasMore', false);
    commit('urlMore', false);
  },

  findPinned({ commit, dispatch, state }) {
    const domain = Context.query().first().domain;
    commit('setLoading', true);
    api.get(`/${domain}/items?pinned`).then(response => {
      dispatch(
        'normalize',
        {
          model: Item,
          data: response.data.data
        },
        { root: true }
      ).then(() => {
        commit('setLoading', false);
      });
    });
  },

  findForTeam({ commit, dispatch, state }) {
    const domain = Context.query().first().domain;

    commit('setLoading', true);
    api.get(`/${domain}/items?type[]=share`).then(response => {
      commit(
        'setHasMore',
        parseInt(response.data._pagination.count) >
          parseInt(response.data._pagination.offset) +
            parseInt(response.data._pagination.limit)
      );

      commit(
        'setUrlMore',
        `${response.data._pagination._links.next.href}&type[]=share`
      );

      dispatch(
        'normalize',
        {
          model: Item,
          data: response.data.data
        },
        { root: true }
      ).then(() => {
        commit('setLoading', false);
      });
    });
  },

  findMore({ commit, dispatch, state }) {
    const domain = Context.query().first().domain;

    api.get(state.urlMore).then(response => {
      commit(
        'setHasMore',
        parseInt(response.data._pagination.count) >
          parseInt(response.data._pagination.offset) +
            parseInt(response.data._pagination.limit)
      );

      commit(
        'setUrlMore',
        `${response.data._pagination._links.next.href}&type[]=share`
      );

      dispatch(
        'normalize',
        {
          model: Item,
          data: response.data.data
        },
        { root: true }
      );
    });
  },

  get({ commit, dispatch, state }, item) {
    api.get(item.selfUrl).then(response => {
      dispatch(
        'normalize',
        {
          model: Item,
          data: response.data.data
        },
        { root: true }
      );
    });
  },

  update({ commit, dispatch, state }, item) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.update(Item, item).then(() => {
        commit('setUpdating', false);
        resolve();
      });
    });
  },

  like({ commit, dispatch, state }, item) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.like(Item, item).then(response => {
        commit('setUpdating', false);
        dispatch('entities/items/get', item, { root: true }).then(() => {
          resolve();
        });
      });
    });
  },

  unlike({ commit, dispatch, state }, item) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.unlike(Item, item).then(response => {
        commit('setUpdating', false);
        dispatch('entities/items/get', item, { root: true }).then(() => {
          resolve();
        });
      });
    });
  },

  pin({ commit, dispatch, state }, item) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.pin(Item, item).then(response => {
        commit('setUpdating', false);
        dispatch('entities/items/get', item, { root: true }).then(() => {
          resolve();
        });
      });
    });
  },

  unpin({ commit, dispatch, state }, item) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.unpin(Item, item).then(response => {
        commit('setUpdating', false);
        dispatch('entities/items/get', item, { root: true }).then(() => {
          resolve();
        });
      });
    });
  },

  remove({ commit }, collection) {
    return new Promise(resolve => {
      collection.forEach(item => {
        commit('setDeleting', true);
        api.remove(Item, item).then(() => {
          Item.delete(item.id);
          commit('setDeleting', false);
          resolve();
        });
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
